// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__hhaqC","contactContent":"Contact_contactContent__DJQKh","contactInputs":"Contact_contactInputs__x299M"};